import React from "react"
import { Typography, Tooltip, styled } from "@mui/material"
import { colors } from "theme"

type Props = {
  tooltip: string
  color: "success" | "error" | "dark" | "default"
  children: React.ReactNode
}

const BadgeComponent = ({ tooltip, color, children }: Props) => {
  const backgroundColor = () => {
    if (color === "success") {
      return colors.persianGreen
    } else if (color === "error") {
      return colors.ruby
    } else if (color === "dark") {
      return colors.black
    } else {
      return colors.romanSilver
    }
  }

  return (
    <Tooltip title={tooltip} placement="top">
      <Badge
        sx={{
          backgroundColor: backgroundColor(),
        }}
      >
        {children}
      </Badge>
    </Tooltip>
  )
}

BadgeComponent.defaultProps = {}

export default BadgeComponent

const Badge = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  borderRadius: "12.5px",
  fontSize: "0.625rem",
  fontWeight: "500",
  lineHeight: "normal",
  padding: "7px 12px",
  [theme.breakpoints.down("md")]: {
    padding: "5px 10px",
  },
}))
